import * as m from "mithril";
import { NavBar } from '../../components/NavBar';
import AppContext from '../../context/AppContext';
import BusLayout from "./BusLayout";
import LoadingIndicator from "../../components/LoadingIndicator";
import './BusLayoutPage.scss';
import { MessageProvider } from "../../context/AppMessages";
import TripSearchResultSummaryView from "../../components/TripSearchResultSummaryView";
import buildLanguageChangeActions from "../common/LanguageNavActions";
import { getIntlStringValue } from "../../helpers/StringHelpers";
import CustomSvgIcon from "../../components/CustomSvgIcon";
import { InternationalStringDTO, MoneyDTO, SeatDTO, SeatPriceGuideItemDTO, TripDTO, TripResultDTO } from "../../apiclient/ApiDtos";
import SearchCriteria from "../../models/SearchCriteria";
import { formatMoney } from "../../helpers/MoneyFormatter";
import SeatPriceDetailsDialog, { getPriceLevelCssClass } from "../tripresult/SeatPriceDetailsDialog";
import MixedSeatTypesWarningDialog from "../tripresult/MixedSeatTypesNotAllowedWarningDialog";


interface SelectedSeatComponentAttrs {
    seat: SeatDTO;
    seatFeatureCssClass: string,
}
export function SelectedSeatComponent(): m.Component<SelectedSeatComponentAttrs> {
    return {
        view(vnode) {
            let seatFeatureClass = vnode.attrs.seatFeatureCssClass;

            return m("span", {
                class: "seat-selection-slot en-only mr-2 " + seatFeatureClass
            },
                vnode.attrs.seat.number);
        }
    };
}

interface Attrs {
    appContext: AppContext,
    hidePriceInfoPopAnimation: boolean,
    searchCriteria: SearchCriteria,
    seatSelections: SeatDTO[],
    isSubmittingSeatReservation: boolean,
    tripResult: TripResultDTO,
    tripDetails: TripDTO | null,
    messageProvider: MessageProvider,
    errorMessage: InternationalStringDTO | null,
    shouldWarnSeatUnchangeable?: boolean,
    onBackPressed: () => void,
    onSelectSeat: (seat: SeatDTO) => void,
    onUnselectSeat: (seat: SeatDTO) => void,
    onSeatReservationRequested: (seats: SeatDTO[]) => void
}


function BusLayoutPage(): m.Component<Attrs> {
    let isHidingSeatSelectionDetails: boolean = true;
    let isListeningScrollOnMain = false;

    let isScrolledToErrorMessageView = false;
    let showSeatTypeWarningMessage = false;
    let showSeatPricingDialog = false;
    let sortedPriceGuide: SeatPriceGuideItemDTO[];

    return {
        view: function (vnode) {
            const { appContext, seatSelections, tripResult, tripDetails, onBackPressed } = vnode.attrs;
            if(tripDetails && tripDetails.seatPlan && tripDetails.seatPlan.priceGuide){
                sortedPriceGuide = [...tripDetails.seatPlan.priceGuide].sort((a, b) => b.price.amount - a.price.amount)
            }
            let showPriceWithDetails = tripDetails
                && (tripDetails.priceRange.max.amount > tripDetails.priceRange.min.amount)
            // && !tripDetails.mixedSeatTypesInBookingAllowed ;

            let currLang = vnode.attrs.messageProvider.getCurrentLang();
            let notices: InternationalStringDTO[] = vnode.attrs.tripResult?.notices || [];

            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);
            let totalSeatPriceCurrency = "MMK";
            let totalSelectedSeatsPriceAmount = seatSelections.reduce((total, seat) => (total + seat.price.amount), 0);
            let totalSeatPrice: MoneyDTO = {
                amount: totalSelectedSeatsPriceAmount,
                currency: totalSeatPriceCurrency
            }

            let isMultipleSeatPricesTrip = tripDetails != null && tripDetails.priceRange.min.amount < tripDetails.priceRange.max.amount;

            if (vnode.attrs.errorMessage != null && !isScrolledToErrorMessageView && !vnode.attrs.isSubmittingSeatReservation) {
                setTimeout(() => {
                    document
                        .getElementById("seat-reservation-error-msg")
                        ?.scrollIntoView({ behavior: "smooth", block: "start" });
                }, 0);
                isScrolledToErrorMessageView = true;
            }
            return m("div.app-layout", [
                m(NavBar, {
                    title: vnode.attrs.appContext.getMessageProvider().get('nav_title.select_seat'),
                    canBackPress: true,
                    actionItems: langChangeActionItems,
                    onBackPressed: () => {
                        vnode.attrs.onBackPressed();
                    }
                }),

                m("div.app-area-below-nav",
                ),

                m("div.app-area-main",
                    /* isListeningScrollOnMain ? {
                        onscroll: (e: UIEvent) => {
                            isHidingSeatSelectionDetails = true;
                            isListeningScrollOnMain = false;
                        }
                    } :
                        {}
                    , */
                    [
                        m("div.card shadow-sm",
                            m("div.card-body p-3", [

                                m(TripSearchResultSummaryView, {
                                    tripResult: vnode.attrs.tripResult,
                                    tripDetails: vnode.attrs.tripDetails || undefined,
                                    numberOfSeats: vnode.attrs.searchCriteria.numberOfSeats,
                                    messageProvider: vnode.attrs.messageProvider,
                                    showingDate: true,
                                    showAsMultipleSeatPrice: true
                                }),

                                (notices.length > 0) ?
                                    m("div", { class: "alert alert-info mt-2 mb-0 p-2" },
                                        [
                                            m("small.font-weight-bold",
                                                vnode.attrs.appContext.getMessageProvider().get("trip.operator_notices", {
                                                    name: getIntlStringValue(tripResult.operator.name, currLang)
                                                })
                                            ),
                                            notices.map(notice => {
                                                return m("div", { class: "small" }, "- " + getIntlStringValue(notice, currLang))
                                            })
                                        ]
                                    )
                                    : null,
                            ])
                        ),
                        vnode.attrs.errorMessage != null ?
                            m("div", { class: "d-flex alert alert-warning mx-3 mt-2 mb-0 p-2", id: "seat-reservation-error-msg" },
                                m(CustomSvgIcon, {
                                    iconType: 'exclamation_triangle',
                                    themeCssClass: 'svg-medium svg-warning'
                                }),
                                m("small.ms-1 ml-1 font-weight-bold", currLang == "en" ? vnode.attrs.errorMessage.en : vnode.attrs.errorMessage.my)
                            ) 
                            : null,

                        vnode.attrs.shouldWarnSeatUnchangeable == true &&
                        m("div", { class: "d-flex alert alert-info mx-3 mt-2 mb-0 p-2", id: "seat-reservation-error-msg" },
                                m(CustomSvgIcon, {
                                    iconType: 'exclamation_circle',
                                    themeCssClass: 'svg-small svg-info'
                                }),
                                m("small.ms-1 ml-1 font-weight-bold", 
                                    currLang == "en" ? "You cannot un-select seat(s). Seat selection is locked." : "ခုံနေရာ ရွေးချယ်မှု ပြန်ပြင်၍ မရတော့ပါ။ နေရာဦးထားပြီးဖြစ်သည်။"
                                )
                            ) ,

                        (tripDetails != null && tripDetails.seatPlan) ?

                            m("div.p-3",

                                showPriceWithDetails && tripDetails &&
                                m("div.mb-2", { style: "position: relative;" },
                                    m("div.text-center", {
                                        onclick: () => {
                                            showSeatPricingDialog = true;
                                        }
                                    }, [

                                        m("span.small text-muted_ text-price-total",
                                            vnode.attrs.messageProvider.get("common.per_seat")
                                            + " ▹ "
                                        ),


                                        m("span.text-muted", " ( "),
                                        m("span.font-weight-bold", { class: "text-success" },
                                            m("small", { class: "text-success" }, "MMK "),
                                            tripDetails.priceRange.min.amount.toLocaleString("en-US"),
                                            m("span.font-weight-normal px-1 text-muted", "to"),
                                            m("small", { class: "text-success" }, "MMK "),
                                            tripDetails.priceRange.max.amount.toLocaleString("en-US")
                                        ),

                                        m("span.text-muted", " ) "),
                                        m("span.clickable-area",
                                            m(CustomSvgIcon, {
                                                iconType: "list_box",
                                                themeCssClass: "svg-info custom-svg-list-box"
                                            })
                                            /* m(CustomSvgIcon, {
                                                iconType: "exclamation_circle",
                                                themeCssClass: " svg-small svg-info"
                                            }) */
                                        ),
                                        (vnode.attrs.tripDetails && !vnode.attrs.hidePriceInfoPopAnimation) &&
                                        m("div.information-pop", vnode.attrs.messageProvider.get("common.see_seat_prices_chart"))
                                    ])
                                ),


                                m(BusLayout, {
                                    isSmallCar: tripDetails.isSmallCar,
                                    isDirectBookableTrip: (tripDetails == null || tripDetails.isDirectBookable),
                                    appContext: vnode.attrs.appContext,
                                    isMultipleSeatPriceTrip: isMultipleSeatPricesTrip,
                                    seatPlan: tripDetails!.seatPlan!,
                                    seatSelections: vnode.attrs.seatSelections,
                                    isSubmittingSeatReservation: vnode.attrs.isSubmittingSeatReservation,
                                    requiredSeatCount: vnode.attrs.searchCriteria.numberOfSeats,
                                    onSeatReservationRequested: function (seats: SeatDTO[]) {
                                        console.log("bus page seats", seats);
                                        vnode.attrs.onSeatReservationRequested(seats);
                                    },
                                    onSelectSeat: function (selectedOne: SeatDTO) {
                                        if (
                                            //vnode.attrs.tripDetails?.isSmallCar == false &&
                                            vnode.attrs.seatSelections.length > 0 &&
                                            !tripDetails.mixedSeatTypesInBookingAllowed &&
                                            seatSelections[0].priceLevel.value !== selectedOne.priceLevel.value
                                        ) {
                                            showSeatTypeWarningMessage = true;
                                        } else {
                                            vnode.attrs.onSelectSeat(selectedOne);
                                            if (seatSelections.length == vnode.attrs.searchCriteria.numberOfSeats) {
                                                isHidingSeatSelectionDetails = false;
                                            }
                                        }

                                    },
                                    onUnselectSeat: function (unselectOne: SeatDTO) {
                                        vnode.attrs.onUnselectSeat(unselectOne);
                                        isHidingSeatSelectionDetails = true
                                    }
                                }),

                                (vnode.attrs.tripDetails && vnode.attrs.tripDetails.seatPlan) &&
                                m(MixedSeatTypesWarningDialog, {
                                    title: vnode.attrs.messageProvider.get("seat_selection.price_level_warning_title"),
                                    message: vnode.attrs.messageProvider.get("seat_selection.price_level_warning_message", {
                                        "operator": currLang == "my" ? tripDetails.operator.name.my : tripDetails.operator.name.en
                                    }),
                                    tripDetails: vnode.attrs.tripDetails!!,
                                    priceGuide: sortedPriceGuide,
                                    messageProvider: vnode.attrs.messageProvider,
                                    shouldOpen: showSeatTypeWarningMessage,
                                    iconType: 'exclamation_circle',
                                    iconThemeClass: " svg-small svg-info",
                                    onClosed: () => {
                                        showSeatTypeWarningMessage = false;
                                    },
                                    actionItems: [
                                        {
                                            label: "OK",
                                            onclick: () => {
                                                showSeatTypeWarningMessage = false;
                                                showSeatPricingDialog = false;
                                            }
                                        }

                                    ]
                                }),

                                (
                                    vnode.attrs.tripDetails 
                                    && (vnode.attrs.tripDetails.priceRange.min.amount < vnode.attrs.tripDetails.priceRange.max.amount) 
                                    && vnode.attrs.tripDetails.seatPlan
                                )
                                &&
                                m(SeatPriceDetailsDialog, {
                                    shouldOpen: showSeatPricingDialog,
                                    title: vnode.attrs.messageProvider.get("common.seat_prices_chart"),
                                    messageProvider: vnode.attrs.messageProvider,
                                    priceGuide: sortedPriceGuide,
                                    iconType: 'exclamation_circle',
                                    iconThemeClass: " svg-small svg-info",
                                    onClosed: () => {
                                        showSeatPricingDialog = false;
                                    },
                                    actionItems: [
                                        {
                                            label: "OK",
                                            onclick: () => {
                                                showSeatPricingDialog = false;
                                            }
                                        }

                                    ]
                                }),

                            ) :
                            m(LoadingIndicator)
                    ]
                ),
                m("div.app-area-footer", [
                    m("div", { class: "card card-elevated-1" },


                        m("div.card-body px-3 py-2", [
                            vnode.attrs.tripResult.isSeatSelectionAllowed && m("div", {
                                onclick: (event) => {
                                    isHidingSeatSelectionDetails = !isHidingSeatSelectionDetails;
                                }
                            },
                                m("div.d-flex justify-content-between align-items-center",
                                    m("div.small font-weight-bold fw-bold text-muted my-2 text-label-primary-light",
                                        vnode.attrs.searchCriteria.numberOfSeats > 1 ?
                                            appContext.getMessageProvider().get("seat_selection.select_n_seats", {
                                                numOfSeats: vnode.attrs.searchCriteria.numberOfSeats
                                            }) :

                                            appContext.getMessageProvider().get("seat_selection.select_one_seat")
                                    ),
                                    vnode.attrs.searchCriteria.numberOfSeats > 1 && seatSelections.length > 0 ?
                                        m("div.d-flex",
                                            m("div.small mr-1 text-info", vnode.attrs.messageProvider.get("price", currLang)),
                                            m(CustomSvgIcon, {
                                                iconType: isHidingSeatSelectionDetails ? 'keyboard_arrow_up' : 'keyboard_arrow_down',
                                                themeCssClass: "svg-info svg-medium"
                                            })

                                        ) : null
                                ),
                                vnode.attrs.searchCriteria.numberOfSeats > 1 && isHidingSeatSelectionDetails ?
                                    m("div.d-flex mb-2", {},
                                        seatSelections.map(function (seat) {
                                            console.debug("SeatNumber: ", seat.number)
                                            return m(SelectedSeatComponent, {
                                                seat: seat,
                                                seatFeatureCssClass: buildSeatFeatureClass(seat.classification)
                                            })
                                        }),
                                        vnode.attrs.searchCriteria.numberOfSeats - seatSelections.length > 0 ?
                                            Array.from({ length: vnode.attrs.searchCriteria.numberOfSeats - vnode.attrs.seatSelections.length }, (_, index) =>
                                                m(
                                                    "span",
                                                    {
                                                        key: index,
                                                        class: "seat-selection-slot mr-2"
                                                    }
                                                )
                                            ) : null,
                                    )
                                    :
                                    [
                                        seatSelections.map(function (seat) {
                                            return m("div.row my-2",
                                                m("div.col-5",
                                                    m(SelectedSeatComponent, {
                                                        seat: seat,
                                                        seatFeatureCssClass: buildSeatFeatureClass(seat.classification)
                                                    })
                                                ),
                                                m("div.col-7.text-right",
                                                    m("span", { class: "text-dark" }, (formatMoney(seat.price)))
                                                ),
                                            )
                                        }),
                                        vnode.attrs.searchCriteria.numberOfSeats - seatSelections.length > 0 ?
                                            Array.from({ length: vnode.attrs.searchCriteria.numberOfSeats - seatSelections.length }, (_, index) =>
                                                m("div.row my-2",
                                                    m("div.col-5",
                                                        m(
                                                            "span",
                                                            {
                                                                key: index,
                                                                class: "seat-selection-slot en-only mr-2",
                                                            }
                                                        )
                                                    ),
                                                    m("div.col-7")
                                                )
                                            )
                                            : null
                                    ],

                                //Total Seat Price
                                vnode.attrs.searchCriteria.numberOfSeats > 1 && seatSelections.length > 0 ?
                                    m("div.row mt-3 mb-2",
                                        m("div.col-5",
                                            m("span", { class: "small mr-2" }, appContext.getMessageProvider().get("total_seat_price"))
                                        ),
                                        m("div.col-7.text-right",
                                            m("span", { class: "text-success font-weight-bold fw-bold" },
                                                seatSelections.length > 0 ?
                                                    formatMoney(totalSeatPrice)
                                                    : null
                                            )
                                        ),
                                    ) : null,


                            ),
                            m("div", { class: "text-right" },
                                vnode.attrs.isSubmittingSeatReservation ?
                                    m("button", {
                                        class: "btn disabled btn-primary text-nowrap form-control"
                                    },
                                        appContext.getMessageProvider().get("seat_selection.submitting")
                                    ) :
                                    m("button", {
                                        class: "btn btn-primary text-nowrap form-control",
                                        disabled: (seatSelections.length == vnode.attrs.searchCriteria.numberOfSeats) ? false : true,
                                        onclick: (event) => {
                                            event.preventDefault();
                                            if (seatSelections.length == vnode.attrs.searchCriteria.numberOfSeats) {
                                                let selectedSeats: SeatDTO[] = seatSelections;
                                                vnode.attrs.onSeatReservationRequested(selectedSeats);
                                            }

                                            isScrolledToErrorMessageView = false;
                                        }
                                    },
                                        appContext.getMessageProvider().get("seat_selection.submit")
                                    )
                            )
                            ,
                        ]
                        ),
                        appContext.isLeavingExtraMarginBottom() ?
                            m("div.app-area-system-nav") : null
                    )

                ])
            ])
        }
    }
}


export default BusLayoutPage;



export function buildSeatFeatureClass(
    classification: string | undefined | null
): string {
    let seatFeatureClass = "";
    seatFeatureClass = (classification) ?
        "seat seat-price-" + classification.toLocaleLowerCase().trim()
        :
        "seat seat-price-standard";

    return seatFeatureClass;
}
